import { idSchema } from "@reactive-resume/schema";
import { dateSchema } from "@reactive-resume/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const permissionSchema = z.object({
  id: idSchema,
  name: z
    .string()
    .min(3)
    .max(100)
    .regex(/^[a-z]+\.[a-z]+$/, {
      message: 'Permission name must follow pattern "module.action" (e.g., "user.create")',
    }),
  description: z.string().optional().nullable(),
  module: z.string().optional().nullable(),
  createdAt: dateSchema,
  updatedAt: dateSchema,
});

export class PermissionDto extends createZodDto(permissionSchema) {}

export const createPermissionSchema = permissionSchema.pick({
  name: true,
  description: true,
  module: true,
});

export class CreatePermissionDto extends createZodDto(createPermissionSchema) {}

export const updatePermissionSchema = createPermissionSchema.partial();

export class UpdatePermissionDto extends createZodDto(updatePermissionSchema) {}
